module.exports = __webpack_public_path__ + "img/rocco.aba26b78.png";